var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgProductNoImage = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 80,
  height: 80,
  fill: "none",
  viewBox: "-1 -1 80 80"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeWidth: "var(--stroke-width, 2)",
  d: "m70 22-29.763 7.255a1 1 0 0 1-.474 0l-28.526-6.953a1 1 0 0 0-1.237.971v33.629a1 1 0 0 0 .763.971l29 7.07a1 1 0 0 0 .474 0l29-7.07a1 1 0 0 0 .763-.971V35.344"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeWidth: "var(--stroke-width, 1)",
  d: "m42 33-2 .313M44.5 36 40 37M46 39.5 40 41M69 38l-29 7M69 42l-29 7M69 46l-29 7M69 50l-29 7M69 54l-29 7"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeWidth: "var(--stroke-width, 2)",
  d: "m11 22 29-6 29 6"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeWidth: "var(--stroke-width, 1)",
  d: "M40 17v12"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeWidth: "var(--stroke-width, 2)",
  d: "m40 29.5 5.747 9.726a2 2 0 0 0 2.191.927l24.986-6.031a2 2 0 0 0 1.272-2.929L69 22M10 23l-5.013 7.326c-.52.76.176 1.758 1.068 1.535L9.5 31"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M20.93 50.306a45 45 0 0 0-1.01-.232v-2.186q-.463-.101-.936-.212v-2.137a62 62 0 0 1-.972-.211V43.18a61 61 0 0 0-.973-.191V41.84L16 41.64v-3.355q1.511.292 3.022.594v1.15l.897.18v-9.422q.549.12 1.087.242v14.108a66 66 0 0 1-1.115-.231v-3.638l-1.01-.202.037-1.058q-.887-.181-1.775-.353v2.137q.434.09.869.171v1.119q.49.09.972.191v2.177q.473.1.935.191v2.197l1.011.222zl.973.222v2.106a666 666 0 0 0 8.037 1.905V52.26q.462.09.935.172v-3.659l.973.121v3.709l-.935-.161V56q-4.997-1.21-9.983-2.469zm.104-19.258V30l1.945.443v1.028zm3.032 10.219-1.087-.202v-9.594q.576.132 1.153.252v4.112q.954.171 1.907.353v1.038q1.446.24 2.89.453v1.109q1.011.12 2.012.231v.998l.945.08v1.059q-.473-.03-.945-.08v-1.019q-.539-.05-1.077-.11v3.083q-.471-.05-.935-.11v-4.092q-.945-.13-1.879-.272v3.063l-1.01-.16v-4.163q-.993-.171-1.984-.353v4.324zm7.82 7.628v-7.709q.557.04 1.114.07v7.76z",
  clipRule: "evenodd"
})));
export default SvgProductNoImage;